import { Injectable, OnDestroy } from '@angular/core';
import { uidI } from '@common/helpers/utils';
import { ProjectExerciseModule } from '@private/project-edit/project-exercises/project-exercise/project-exercise.module';
import { ExerciseCostDbService } from '@shared/database/exercise-cost-db.service';
import { ExSrvEcosysAssetDbService } from '@shared/database/ex-srv-ecosys-asset-db-service';
import { ExerciseDbService } from '@shared/database/exercise-db-service';
import { ExerciseEcoserviceDbService } from '@shared/database/exercise-ecoservice-db-service';
import { ExerciseEcoserviceEcosystemDbService } from '@shared/database/exercise-ecoservice-ecosystem-db-service';
import { EcosystemServiceModel } from '@shared/models/ecosystem-service.model';
import { ExerciseCostModel } from '@shared/models/exercise-cost.model';
import { ExerciseEcoserviceEcosystemModel } from '@shared/models/exercise-ecoservice-ecosystem.model';
import { ExerciseEcoserviceModel } from '@shared/models/exercise-ecoservice.model';
import { ExerciseModel } from '@shared/models/exercise.model';
import { Ecosystem } from '@shared/models/general.model';
import { ProjectModel } from '@shared/models/project.model';
import { AppService } from 'projects/admin/src/app/core/services/app.service';
import { BehaviorSubject, distinctUntilKeyChanged, firstValueFrom, map, Observable, of, shareReplay, switchMap, take, tap } from 'rxjs';
import { filter as rxjsFilter } from 'rxjs';
import { ExerciseAssetMetaDbService } from '@shared/database/exercise-asset-meta-db.service';
import { cloneDeep, filter as filter, isEmpty } from 'lodash';
import { ExSrvEcosysAssetModel } from '@shared/models/exSrvEcosysAsset.model';
import { updatedDiff } from 'deep-object-diff';
import { ApiServerService } from '@common/api-server/api-server';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ExerciseService implements OnDestroy {
  // private _project = new BehaviorSubject<ProjectModel>(null);
  // public project$ = this._project.asObservable();

  //FIXME ACOMODAR EL CASO DE VACIO, CUANDO NO HAY VALOR


  private _exercise = new BehaviorSubject<ExerciseModel>(null);
  public exercise$ = this._exercise.asObservable();

  public exerciseEcoservices$ = this.exercise$.pipe(
    switchMap(exercise => exercise ? this.exerciseEcoserviceDbService.queryBy$({ 'exercise.id': exercise.id }) : of([])),
    // tap(res=> console.log("GET exerciseEcoservices:", res)),
    shareReplay(1)
  )

  public exerciseEcoservicesEcosystems$: Observable<Array<ExerciseEcoserviceEcosystemModel>> = this.exercise$.pipe(
    switchMap(exercise => exercise ? this.exerciseEcoserviceEcosystemDbService.queryBy$({ 'exercise.id': exercise.id }) : of([])),
    shareReplay(1)
  )

  public exerciseAssetMetas$ = this.exercise$.pipe(
    switchMap(exercise => exercise ? this.exerciseAssetMetaDbService.queryBy$({ 'exercise.id': exercise.id }) : of([])),
    shareReplay(1)
  )

  // serviceAssets$:Observable<ExSrvEcosysAssetModel[]> = (ecoservice: any) => this.exercise$.pipe(
  serviceAssets$ = (ecoservice: any): Observable<{ assets: ExSrvEcosysAssetModel[], ecoservice: any }> => this.exercise$.pipe(
    rxjsFilter(exercise => !!exercise?.id),
    distinctUntilKeyChanged('id'),
    switchMap(exercise => this.exSrvEcosysAssetDbService.queryBy$({ "exercise.id": exercise.id, "ecoservice.id": ecoservice.id })),
    map(assets => ({ assets, ecoservice })),
    shareReplay(1)
  )
  // serviceAssets$ = (ecoservice)=>{
  //   return this.exercise$.pipe(
  //     switchMap(exercise=> exercise.id
  //       ? this.exSrvEcosysAssetDbService.queryBy$({"exercise.id":exercise.id, "ecoservice.id":ecoservice.id})
  //       :of([])
  //     )
  //   )
  // }

  //Getters
  cardExercises$ = (project: ProjectModel) => (project?.id ? this.exerciseDbService.queryBy$({ 'project.id': project.id }) : of(null)).pipe(shareReplay(1));
  getExercise$ = (id: string) => (id ? this.exerciseDbService.get$(id) : of(null)).pipe(shareReplay(1), tap(e => { this._exercise.next(e) }));
  getExerciseCosts$ = (id: string): Observable<ExerciseCostModel[]> => (id ? this.exerciseCostDbService.queryBy$({ 'exercise.id': id }) : of([])).pipe(shareReplay(1));
  getExerciseEcoservice$ = (id: string): Observable<any> => this.exerciseEcoserviceDbService.get$(id).pipe(shareReplay(1))
  get exercise() {
    return this._exercise.value;
  }
  //

  assets$ = this.exercise$.pipe(switchMap(exercise => this.exSrvEcosysAssetDbService.queryBy$({ 'exercise.id': exercise.id })))

  constructor(
    private exerciseDbService: ExerciseDbService,
    private exerciseEcoserviceDbService: ExerciseEcoserviceDbService,
    private exerciseEcoserviceEcosystemDbService: ExerciseEcoserviceEcosystemDbService,
    private exerciseCostDbService: ExerciseCostDbService,
    private exerciseAssetMetaDbService: ExerciseAssetMetaDbService,
    private appService: AppService,
    private exSrvEcosysAssetDbService: ExSrvEcosysAssetDbService,
    private aSS: ApiServerService,
    private translateService: TranslateService,
  ) { }

  ngOnDestroy() {
    // console.log('exercise is destroyed');
  }

  async create(data: { project: any; period: Date }): Promise<ExerciseModel> {
    const { project, period } = data;
    const projectId = project.id;
    try {
      return await firstValueFrom(this.aSS.call(`api/exercises/create/`, { period, projectId }));
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  edit(excerciseData: { id: string; }) {
    return this.exerciseDbService.upsert(excerciseData);
  }

  delete(exercise: { id: any; }) {
    return this.exerciseDbService.delete(exercise.id);
  }

  //CRUD exercise Ecosystems

  // addEcosystem(data:{exercise:ExerciseModel, ecosystem:ExerciseModel.Ecosystem}){
  //   const {exercise, ecosystem} = data;
  //   exercise.ecosystems = exercise.ecosystems ?? [];
  //   ecosystem.id =  uidI();
  //   const updateData: Partial<ExerciseModel> = {
  //     id: exercise.id,
  //     ecosystems:[...exercise.ecosystems, ecosystem]
  //   }
  //   return this.exerciseDbService.upsert(updateData);
  // }
  // editEcosystem(data:{exercise:ExerciseModel, ecosystem:ExerciseModel.Ecosystem}){
  //   const {exercise, ecosystem} = data;
  //   const index = exercise.ecosystems.findIndex(e=> e.id == ecosystem.id);
  //   exercise.ecosystems[index] = ecosystem;
  //   const updateData: Partial<ExerciseModel> = {
  //     id: exercise.id,
  //     ecosystems:[...exercise.ecosystems]
  //   }
  //   return this.exerciseDbService.upsert(updateData);
  // }

  upsertEcosystem(data: { exercise: ExerciseModel, ecosystem: ExerciseModel.Ecosystem }) {
    const { exercise, ecosystem } = data;
    const ecosystems = [...exercise.ecosystems];
    if (ecosystem.id) {
      //Update
      const index = ecosystems.findIndex(e => e.id == ecosystem.id);
      ecosystems[index] = ecosystem;
    } else {
      //Insert
      ecosystem.id = uidI();
      ecosystems.push(ecosystem)
    }
    const updateData: Partial<ExerciseModel> = {
      id: exercise.id,
      ecosystems
    }
    return this.exerciseDbService.upsert(updateData);
  }

  //Actualiza primero el Ecosystema y luego lo sservicios asociados
  async upsertEcosystemFull(data: { exercise: ExerciseModel, ecosystem: ExerciseModel.Ecosystem, exerciseEcoservicesEcosystems: Array<ExerciseEcoserviceEcosystemModel>, diffEcoServices: any }) {
    const { diffEcoServices, ecosystem, exerciseEcoservicesEcosystems } = data;
    const res = await this.upsertEcosystem(data);
    const ecoServices = await firstValueFrom(this.appService.ecoservices$);

    for (let index = 0; index < ecoServices.length; index++) {
      const _ecoService = ecoServices[index];
      if (diffEcoServices[index] !== undefined) {
        const exerciseEcoserviceEcosystems = exerciseEcoservicesEcosystems.filter(e => e.ecoservice.id == _ecoService.id)
        if (diffEcoServices[index]) {
          await this.activateEcosystem(ecosystem, _ecoService, exerciseEcoserviceEcosystems)
        } else {
          await this.deactivateEcosystem(ecosystem, _ecoService, exerciseEcoserviceEcosystems)
        }
      }
    }
    return res;
  }

  async deleteEcosystem(data: { exercise: ExerciseModel, ecosystem: ExerciseModel.Ecosystem }) {
    const { exercise, ecosystem } = data;
    const ret = await new Promise(resolve => {
      this.appService.confirmationService.confirm({
        header: this.translateService.instant('LABEL.PLEASE_CONFIRM'),
        message: this.translateService.instant('LABEL.DELETE_ECOSYSTEM_CONFIRMATION', { name: ecosystem.name }),
        icon: 'pi pi-exclamation-triangle',
        accept: () => resolve(true),
        reject: () => resolve(false)
      });
    })

    if (ret) {
      //ELiminamos los assest de los ecosystemas de los servicios
      const exerciseEcoservicesEcosystems = await firstValueFrom(this.exerciseEcoservicesEcosystems$);
      await this.deleteExerciseEcoservicesEcosystems(ecosystem, exerciseEcoservicesEcosystems)

      const updateData: Partial<ExerciseModel> = {
        id: exercise.id,
        ecosystems: exercise.ecosystems.filter(_e => _e.id !== ecosystem.id)
      }
      return this.exerciseDbService.upsert(updateData);
    }
  }

  async deleteExerciseEcoservicesEcosystems(ecosystem: ExerciseModel.Ecosystem, exerciseEcoservicesEcosystems: any[]) {
    const affectedExerciseEcoservicesEcosystems = exerciseEcoservicesEcosystems.filter((eee: { ecosystem: { id: any; }; }) => eee.ecosystem.id == ecosystem.id);
    for (const element of affectedExerciseEcoservicesEcosystems) {
      await this.exerciseEcoserviceEcosystemDbService.delete(element.id);
    }
    //TODO Debemos hacer un batchDelete
    //FIXME Debemos revisar si el servicio sigue teneiendo ecosystemas activos para desactivarlo
  }


  async activateEcosystem(ecosystem: Ecosystem, ecoservice: Partial<EcosystemServiceModel>, exerciseEcoserviceEcosystems: ExerciseEcoserviceEcosystemModel[]) {
    const exerciseEcoservices = await firstValueFrom(this.exerciseEcoservices$);
    this.setExerciseEcoservice(exerciseEcoservices, ecoservice);
    this.setExerciseEcoserviceEcosystem(exerciseEcoserviceEcosystems, ecosystem, ecoservice)
  }

  async deactivateEcosystem(ecosystem: Ecosystem, ecoservice: Partial<EcosystemServiceModel>, exerciseEcoserviceEcosystems: ExerciseEcoserviceEcosystemModel[]) {
    const exerciseEcoservices = await firstValueFrom(this.exerciseEcoservices$);
    const _exerciseEcoserviceEcosystem = exerciseEcoserviceEcosystems.find(eee => eee.ecosystem.id == ecosystem.id);
    const exercise = this._exercise.value;
    if (_exerciseEcoserviceEcosystem) {
      _exerciseEcoserviceEcosystem.status = 'disable';
      await this.exerciseEcoserviceEcosystemDbService.upsert(_exerciseEcoserviceEcosystem);

      const ecosystemEnabled = exerciseEcoserviceEcosystems.find(eee => eee.status !== 'disable');
      if (!ecosystemEnabled) {
        const _exerciseEcoservice = exerciseEcoservices.find(ee => ee.ecoservice.id == ecoservice.id);
        if (_exerciseEcoservice) {
          _exerciseEcoservice.status = 'disable';
          await this.exerciseEcoserviceDbService.upsert(_exerciseEcoservice);
        }
      }
    }
  }

  updateExerciseEcoservice(properties: Partial<ExerciseEcoserviceModel>) {
    // console.log("properties", properties)
    return this.exerciseEcoserviceDbService.upsert(properties);
  }
  updateTotals(totals, ecoservice: ExerciseEcoserviceModel) {
    const { exploitedHa, exploitedAssets, totalHa, totalAssets, exploitedValue, exploitedPresent, totalValue, presentValue } = totals;
    let { physical, monetary } = ecoservice;


    const updateObj: Partial<ExerciseEcoserviceModel> = {};
    if (!physical || !isEmpty(updatedDiff(physical, {  exploitedHa, exploitedAssets, totalHa, totalAssets }))) {
      physical = physical ?? {
        exploitedHa:null, exploitedAssets: null,
        totalHa: null, totalAssets: null,
        expectedProjection: null, normalized: null, note: '' };
      updateObj.physical = { ...physical, exploitedHa, exploitedAssets, totalHa, totalAssets }
      //Actualiza el normalized.value;
      if (!updateObj.physical.normalized) {
        updateObj.physical.normalized = {
          min: null,
          max: null,
          value: null
        }

      }
      updateObj.physical.normalized.value = ExerciseEcoserviceModel.normalize(updateObj.physical);
    }
    if (!monetary || !isEmpty(updatedDiff(monetary, { exploitedValue, exploitedPresent, totalValue, presentValue }))) {
      monetary = monetary ?? {
        exploitedValue: null, exploitedPresent: null,
        totalValue: null, presentValue: null,
        uncertaintyLevel: null, note: '' }
      updateObj.monetary = { ...monetary, exploitedValue, exploitedPresent, totalValue, presentValue }
    }



    if (!isEmpty(updateObj)) {
      updateObj.id = ecoservice.id;
      return this.exerciseEcoserviceDbService.upsert(updateObj);
    } else {
      return false;
    }
  }

  setExerciseEcoservice(exerciseEcoservices: ExerciseEcoserviceModel[], ecoservice: Partial<EcosystemServiceModel>) {
    //Si no existe el exerciseEcosystem crearlo con draft, si está disable colocarlo en draft.
    const _exerciseEcoservice = exerciseEcoservices.find(ee => ee.ecoservice.id == ecoservice.id);
    const exercise = this._exercise.value;
    const exerciseEcoservice = _exerciseEcoservice ? _exerciseEcoservice : ExerciseEcoserviceModel.create(exercise, ecoservice);
    if (exerciseEcoservice.status == 'disable') {
      exerciseEcoservice.status = 'draft'
    }
    return this.exerciseEcoserviceDbService.upsert(exerciseEcoservice);
  }

  setExerciseEcoserviceEcosystem(exerciseEcoserviceEcosystems: ExerciseEcoserviceEcosystemModel[], ecosystem: Ecosystem, ecoservice: Partial<EcosystemServiceModel>) {
    //Si no existe lo creamos, si está en disable lo colocamos en draft
    const _exerciseEcoserviceEcosystem = exerciseEcoserviceEcosystems.find(eee => eee.ecosystem.id == ecosystem.id);
    const exercise = this._exercise.value;

    const exerciseEcoserviceEcosystem = _exerciseEcoserviceEcosystem ?? ExerciseEcoserviceEcosystemModel.create(exercise, ecoservice, ecosystem);
    if (exerciseEcoserviceEcosystem.status == 'disable') {
      exerciseEcoserviceEcosystem.status = 'draft'
    }
    return this.exerciseEcoserviceEcosystemDbService.upsert(exerciseEcoserviceEcosystem);
  }


  setExerciseCostModel(exerciseCostModel: ExerciseCostModel) {
    exerciseCostModel.exercise = ExerciseModel.genRef(this._exercise.value);
    this.exerciseCostDbService.upsert(exerciseCostModel)
      .then(resp => {
        // console.log("OK");
      })
      .catch(err => {
        console.error('Error', err);
      })
      ;
  }
  deleteExerciseCostModel(id: string) {
    this.exerciseCostDbService.delete(id)
      .then(resp => {
        // console.log("OK");
      })
      .catch(err => {
        console.error('Error', err);
      })
      ;
  }
}
